<template>
    <div>
        <div class="row">
            <div class="col-md-12 col-sm-12 ">
                <div class="x_panel">
                    <h2 class="float-left">Critical Maintenance History Report</h2>
                    <button v-if="listMode" @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>

                  <button v-if="listMode && isPermissionExist(PERMISSIONS.CRITICAL_MAINTENANCE_HISTORY_REPORT_PRINT)" @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                    <i class="fa fa-print" v-if="!isPrinting"></i>
                    <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                    {{ isPrinting ? 'Printing...' : 'Print' }}
                  </button>
                  <vue-excel-xlsx
                    v-if="listMode && isPermissionExist(PERMISSIONS.CRITICAL_MAINTENANCE_HISTORY_REPORT_PRINT)"
                    ref="excel"
                    :data="excelData"
                    :columns="excelHeader"
                    :file-name="'Critical Maintenance History List'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    :disabled="isPrinting"
                    class="btn btn-primary btn-sm float-right"
                  >
                    <div
                      @click.prevent="handleExportPrint('excel')"
                    >
                      <i class="fa fa-file-excel-o"></i>
                      {{ isPrinting ? 'Preparing...' : 'Excel' }}
                    </div>
                  </vue-excel-xlsx>
                </div>
                <div class="">
                    <div class="x_content ">
                        <div class="row" v-if="listMode && jobList">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label>Vessel</label>
                                                    <select class="form-control" v-model="scheduleInfo.vesselId">
                                                        <option value="" selected>Select Vessel</option>
                                                        <option v-for="(row, key) in vessels" :key="row?.id" :value="row?.id">{{row?.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Date From</label>
                                                    <DatePicker type="date" v-model="scheduleInfo.date_from" valueType="format"></DatePicker>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Date To</label>
                                                    <DatePicker type="date" v-model="scheduleInfo.date_to" valueType="format"></DatePicker>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Counter Type</label>
                                                    <select class="form-control" v-model="scheduleInfo.listType">
                                                        <option value>Select Job Interval</option>
                                                        <option value="Yearly">Yearly</option>
                                                        <option value="Two-Yearly">2 yearly</option>
                                                        <option value="Thirty-Monthly">2.5 yearly</option>
                                                        <option value="Three-Yearly">3 yearly</option>
                                                        <option value="Four-Yearly">4 yearly</option>
                                                        <option value="Five-Yearly">5 yearly</option>
                                                        <option value="Ten-Yearly">10 yearly</option>
                                                        <option value="Fifteen-Yearly">15 yearly</option>
                                                        <option value="Monthly">Monthly</option>
                                                        <option value="Three-Monthly">3 Monthly</option>
                                                        <option value="Six-Monthly">6 Monthly</option>
                                                        <option value="Weekly">Weekly</option>
                                                        <option value="Running Hours">Running Hour</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Department</label>
                                                    <select v-model="scheduleInfo.department_id" name="department_id" class="form-control" @change="getMainComponent(scheduleInfo.department_id)">
                                                        <option value selected>Select department</option>
                                                        <option v-for="sdepartment in departments" :key="sdepartment?.id" :value="sdepartment?.id">{{ sdepartment?.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Main Component</label>
                                                    <select v-model="scheduleInfo.main_component_id" name="main_component_id" class="form-control" @change="getComponentList(scheduleInfo.main_component_id)">
                                                        <option value selected>Select main component</option>
                                                        <option v-for="mainComponent in mainComponents" :key="mainComponent?.id" :value="mainComponent?.id">{{ mainComponent?.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Component</label>
                                                    <select v-model="scheduleInfo.component_id" name="component_id" class="form-control" @change="getSubComponent(scheduleInfo.component_id)">
                                                        <option value selected>Select component</option>
                                                        <option v-for="component in components" :key="component?.id" :value="component?.id">{{ component?.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Sub Component</label>
                                                    <select v-model="scheduleInfo.sub_component_id" name="component_id" class="form-control" @change="getSubSubComponent(scheduleInfo.sub_component_id)">
                                                        <option value="0" selected>Select Sub component</option>
                                                        <option v-for="subcomponent in subcomponents" :key="subcomponent?.id" :value="subcomponent?.id">{{ subcomponent?.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Sub Sub Component</label>
                                                    <select v-model="scheduleInfo.sub_sub_component_id" name="component_id" class="form-control">
                                                        <option value="0" selected>Select Sub Sub component</option>
                                                        <option v-for="subsubcomponent in subsubcomponents" :key="subsubcomponent?.id" :value="subsubcomponent?.id">{{ subsubcomponent?.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6">
                                                <div class="form-group">
                                                    <label for="">Maintenance Type </label>
                                                    <select class="form-control" v-model="scheduleInfo.maintenance_type">
                                                        <option value>Select</option>
                                                        <option value="planned">Planned</option>
                                                        <option value="breakdown">Breakdown</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-6 ">
                                                <div class="form-group">
                                                    <label for="">Search </label>
                                                    <input type="text" v-model="scheduleInfo.searchInput" placeholder="Enter Job Name" name="searchInput" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-2 mt-2">
                                                <div class="form-group">
                                                    <label for=""></label>
                                                    <button class=" mt-3 btn-info btn btn-sm" @click="getAllJobList()">Search</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
                                            <PulseLoader :loading="loading"></PulseLoader>
                                        </div>

                                        <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                                        <div v-if="!loading" class="card-box table-responsive">
                                            <TableData
                                              :jobList="jobList?.data"
                                                       :jobDoneFunction="jobDoneFunction"
                                                      :currentPage="Number(jobList?.current_page)"
                                                      :perPage="Number(jobList?.per_page)"
                                            />
                                            <div id="printArea" style="display: none">
                                                <div style="text-align: center;line-height: 20px;">
                                                    <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                    <div style="line-height: 10px;" class="font-weight-bold">Critical Maintenance History List</div>
                                                    <p style="line-height: 10px;"><span v-if="scheduleInfo.date_from">From: {{scheduleInfo.date_from}}</span> <span v-if="scheduleInfo.date_to">To: {{scheduleInfo.date_to}}</span></p>
                                                    <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                                </div>
                                                <TableData :jobList="printItems" :isPrinting="true"/>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="listMode && jobList">
                            <Pagination :pagination="jobList" :getData="getAllJobList"/>
                        </div>

                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import {VueEditor} from 'vue2-editor'
    import auth from '../../../auth'
    import JobDone from '../JobDone.vue'
    import TableData from './TableData.vue'
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import {apiPrintData} from "@/utils/print";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        name: 'critical-maintenance-history-report',
        components: {
            VueEditor,
            JobDone,
            DatePicker,
            TableData,
            PulseLoader
        },
        data() {
            return {
                loading: false,
                reportList: false,
                isPrinting: false,
                color: '#1ABB9C',
                size: '10px',
                jobId: 25,
                selectedComponent: '',
                vessels: null,
                selectedJob: Object,
                treeDisplayData: [],
                printItems: [],
                appName: process.env.VUE_APP_NAME,
                permissions: auth.getPermissionData(),
                scheduleData: '',
                job_name: '',
                componentName: '',
                jobType: '',
                query: '',
                content: '',
                queryFiled: 'name',
                jobList: [],
                jobListWithOutPagination: [],
                jobRemarks: '',
                listMode: true,
                IRR: false,
                P2W: false,
                JobDoneStatus: false,
                DeferReschedule: false,
                editMode: false,
                permitWorkMode: false,
                tableEnableMode: false,
                chiefPermisionMode: false,
                departments: [],
                mainComponents: [],
                components: [],
                subcomponents: [],
                subsubcomponents: [],
                vessel_id: auth.getVesselId(),
                user_type: auth.getUserType(),
                offset: 20,
                form: new Form({
                    id: '',
                    name: '',
                    email: '',
                    status: 'Activate'
                }),
                pagination: {
                    current_page: 1,
                    offset: 5
                },
                filter: new Form({
                    dateRange: '',
                    jobType: '',
                    jobId: '',
                    vessel_id: auth.getVesselId(),
                }),
                scheduleInfo: new Form({
                    vesselId: auth.getVesselId(),
                    listType: '',
                    date_from: '',
                    date_to: '',
                    department_id: '',
                    main_component_id: '',
                    component_id: '',
                    sub_component_id: '0',
                    sub_sub_component_id: '0',
                    filterDate: '',
                    searchInput: '',
                    maintenance_type: '',
                }),
                excelHeader: [],
                excelData: []
            }
        },
        mounted() {
            this.getVessel();
            this.getAllJobList();
            this.departmentList();
        },
        computed: {
            getTableClasses() {
                return {
                    'table': true,
                    'text-center': true,
                    'table-striped': !this.isPrinting,
                    'table-bordered': !this.isPrinting,
                    'table-sm': !this.isPrinting,
                    'print-table': this.isPrinting,
                };
            }
        },
        methods: {
            getVessel() {
              let params = {
                is_all: 1
              }
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel;
                }).catch(e => {
                    console.log(e);
                });
            },

            onPerPageChange() {
              this.getAllJobList(1);
            },
          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              const job = item?.job;

              let componentText = 'N/A';

              if (job?.sub_sub_component) {
                componentText = `${job.sub_sub_component.name} (${job.sub_sub_component.code}) >> ${job.sub_component?.name || ''}`;
              }
              else if (job?.sub_component) {
                componentText = `${job.sub_component.name} (${job.sub_component.code}) >> ${job.component?.name || ''}`;
              }
              else if (job?.component) {
                componentText = `${job.component.name} (${job.component.code})`;
              }

              rows.push({
                '#': index + 1,
                'Job Name(Code)': `${job?.name || ''} (${job?.code || ''})`,
                'Department Name(Code)': `${job?.department?.name || ''} (${job?.department?.code || ''})`,
                'Component Name(Code)': componentText,
                'Due Date': `${item?.due_date || ''}`,
                'Completion Date': `${item?.end_date || ''}`,
                'Counter Type': `${item?.counter_type || ''}`,
                'Assign To': `${item?.job?.rank_fixed_role?.name || ''}`,
                'Status': `${item?.status || ''}`,
              });
            });


            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.vessel_id,
                date_from: this.scheduleInfo.date_from,
                date_to: this.scheduleInfo.date_to,
                listType: this.scheduleInfo.listType,
                department_id: this.scheduleInfo.department_id,
                main_component_id: this.scheduleInfo.main_component_id,
                component_id: this.scheduleInfo.component_id,
                sub_component_id: this.scheduleInfo.sub_component_id,
                sub_sub_component_id: this.scheduleInfo.sub_sub_component_id,
                vesselId: this.scheduleInfo.vesselId,
                searchInput: this.scheduleInfo.searchInput,
                maintenance_type: this.scheduleInfo.maintenance_type,
                critical_component: "Yes",
                is_all: 1,
                offset: this.offset,
              };

              const res = await this.$http.get('/api/filter/all-job-maintenance-history-list', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Maintenance History List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            getAllJobList(page = 1) {
                this.loading = true;
                this.jobList = [];
                let params = {
                    date_from: this.scheduleInfo.date_from,
                    date_to: this.scheduleInfo.date_to,
                    listType: this.scheduleInfo.listType,
                    department_id: this.scheduleInfo.department_id,
                    main_component_id: this.scheduleInfo.main_component_id,
                    component_id: this.scheduleInfo.component_id,
                    sub_component_id: this.scheduleInfo.sub_component_id,
                    sub_sub_component_id: this.scheduleInfo.sub_sub_component_id,
                    vesselId: this.scheduleInfo.vesselId,
                    searchInput: this.scheduleInfo.searchInput,
                    maintenance_type: this.scheduleInfo.maintenance_type,
                    critical_component: "Yes",
                    page: page,
                    is_all: 0,
                    offset: this.offset,
                };
                this.$http.get('/api/filter/all-job-maintenance-history-list', {
                    params
                }).then(response => {
                    this.loading = false;
                    this.jobList = response.data?.success;
                }).catch(e => {
                    this.loading = false;
                    let response = e?.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        console.log(e)
                    }
                });
            },
          departmentList() {
            this.$http.get('/api/filter/get-active-department/' + this.vessel_id).then((response) => {
              this.departments = response.data.success;
            }).catch((e) => {
              console.log(e)
            });
          },
            getMainComponent(department_id) {
                this.mainComponents = [];
                this.components = [];
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.scheduleInfo.main_component_id = '';
                this.scheduleInfo.component_id = '';
                this.scheduleInfo.sub_component_id = '0';
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (department_id !== '') {
                    this.$http.get('/api/filter/main-component/' + this.vessel_id + '/' + department_id, {params}).then((response) => {
                        this.mainComponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getComponentList(main_component_id) {
                this.components = [];
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.scheduleInfo.component_id = '';
                this.scheduleInfo.sub_component_id = '0';
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (main_component_id !== '') {
                    this.$http.get('/api/filter/component/' + this.vessel_id + '/' + main_component_id, {params}).then((response) => {
                        this.components = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getSubComponent(component_id) {
                this.subcomponents = [];
                this.subsubcomponents = [];
                this.scheduleInfo.sub_component_id = '0';
                this.scheduleInfo.sub_sub_component_id = '0';
                let params = {
                  is_all: 1
                }
                if (component_id != '0') {
                    this.$http.get('/api/filter/sub-component/' + this.vessel_id + '/' + component_id, {params}).then((response) => {
                        this.subcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            getSubSubComponent(sub_component_id) {
                let params = {
                  is_all: 1
                }
                this.subsubcomponents = [];
                this.scheduleInfo.sub_sub_component_id = '0';
                if (sub_component_id != '0') {
                    this.$http.get('/api/filter/sub-sub-component/' + this.vessel_id + '/' + sub_component_id, {params}).then((response) => {
                        this.subsubcomponents = response.data.success;
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },
            jobDoneFunction(job) {
                if (job?.job_done_report && job?.job_done_report != null) {
                    this.permitWorkMode = true
                } else {
                    this.permitWorkMode = false
                }
                if (this.user_type != job?.job?.rank_fixed && job?.job_done_report == null) {
                    this.$snotify.warning('Job Done Report is not Submitted')
                } else {
                    this.listMode = false;
                    this.IRR = false;
                    this.P2W = false;
                    this.JobDoneStatus = true;
                    this.selectedJob = job?.job;
                    this.scheduleData = job;
                    let job_name = job?.job?.name + '(' + job?.job?.code + ')';
                    this.job_name = job_name;
                    this.componentName = job?.job?.component?.name
                }

            },
            //this function use for change list mode
            changeListMode() {
                this.IRR = false;
                this.P2W = false;
                this.JobDoneStatus = false;
                this.DeferReschedule = false;
                this.listMode = true;
                this.getAllJobList()
            }
        }
    }
</script>

<style scoped>
    .mx-datepicker {
        width: 100% !important;
    }

</style>
